import { useState } from 'react'
import { Box, Button } from '@material-ui/core'
import { Formik, Form } from 'formik'
import { connect } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import axios from 'axios'
import * as Yup from 'yup'
import history from '../../routes/history'
import FormikControl from '../../Formik/FormikControl'
import urlStrings from '../../utils/urlStrings'
import { ENPHASE_INSTALLER } from '../../layouts/SignInBody/constants'
import { setCurrentUser } from '../../AppRedux/actions/Auth'
import { userService } from '../../Services/UserService'
import { useStyles } from './styles.js'

import {
  setCompanyName,
  setIsInstaller,
  setSessionToken,
  setSessionId,
  setUserName,
} from '../../utils/helper'
import urlEnlightenStrings from '../../utils/urlEnlightenStrings'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}
const EmailIdPassword = (props) => {
  const { setLoading } = props
  const [validated, setValidated] = useState(false)
  const [openBodySnackBar, setOpenBodySnackBar] = useState(false)
  const initialValues = {
    emailId: '',
    password: '',
  }
  const validationSchema = Yup.object({
    emailId: Yup.string().required('*required'),
    password: Yup.string().required('*required'),
  })
  const config = {
    headers: { 'Content-Type': 'application/json' },
  }
  const handleBodySnackBarClose = () => {
    setOpenBodySnackBar(false)
  }
  const reactOnSubmit = (values, formik) => {
    setLoading(true)
userService.loginUser(values)
      .then((data) => {
        formik.resetForm()
        setOpenBodySnackBar(true)
        setValidated(true)
        setLoading(false)
        const user = data
        props.setCurrentUser(user)
        setSessionToken(user?.token)
        setSessionId(user?.session_id)
        setCompanyName(user?.company_name)
        setUserName(`${user?.first_name} ${user?.last_name}`)
        const is_installer = user?.is_installer
        if (is_installer) {
          history.push('/installer')
          setIsInstaller(true)
        } else {
          history.push('/customersupport')
          setIsInstaller(false)
        }
      })
      .catch((error) => {
        setOpenBodySnackBar(true)
        setValidated(false)
        setLoading(false)
      })
  }

  const classes = useStyles()
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={reactOnSubmit}
      >
        {(formik) => (
          <Form className={classes.layout}>
            {openBodySnackBar ? (
              validated ? (
                <Snackbar
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                  open={openBodySnackBar}
                  onClose={handleBodySnackBarClose}
                  key={'top' + 'center'}
                >
                  <Alert onClose={handleBodySnackBarClose} severity="success">
                    Logged In successfully!
                  </Alert>
                </Snackbar>
              ) : (
                <Snackbar
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                  open={openBodySnackBar}
                  onClose={handleBodySnackBarClose}
                  key={'top' + 'center'}
                >
                  <Alert onClose={handleBodySnackBarClose} severity="error">
                    Entered Email ID or Password is incorrect
                  </Alert>
                </Snackbar>
              )
            ) : null}
            <Box>
              <FormikControl
                control="input"
                type="email"
                label="EMAIL ID"
                name="emailId"
                inputlabel="Email"
                onValueChange={(event) => {
                  formik.setFieldValue('emailId', event.target.value)
                }}
                value={formik.values.emailId}
              ></FormikControl>
            </Box>
            <Box>
              <FormikControl
                control="input"
                type="password"
                label="PASSWORD"
                name="password"
                inputlabel="Password"
                onValueChange={(event) => {
                  formik.setFieldValue('password', event.target.value)
                }}
                value={formik.values.password}
              ></FormikControl>
            </Box>

            <Box className={classes.loginhelpoutinstaller}>
              <a
                href={urlEnlightenStrings.getApiUrl('manager/registration')}
                style={{ color: '#026AE3', textDecoration: 'none' }}
                target="_blank"
              >
                SignUp
              </a>
              <a
                href={urlEnlightenStrings.getApiUrl('forgot_password')}
                style={{ color: '#026AE3', textDecoration: 'none' }}
                target="_blank"
              >
                Forgot Password
              </a>
            </Box>

            <Box className={classes.submit}>
              <Button
                variant="contained"
                type="submit"
                style={{
                  backgroundColor: '#F37320',
                  color: 'white',
                  fontWeight: 'bold',
                  padding: '0.7em',
                  height: '100%',
                  width: '60%',
                }}
              >
                SIGN IN
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </>
  )
}
const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (payload) => dispatch(setCurrentUser(payload)),
})
export default connect(null, mapDispatchToProps)(EmailIdPassword)
